<template>
  <router-view />
</template>

<script>
export default {
  name: 'SchemesViewNotesRouter',
};
</script>
